import type { RecoilValueReadOnly } from 'recoil'
import { caseValuesAtom } from '@/atoms'

type GetRecoilValue = <T>(recoilVal: RecoilValueReadOnly<T>) => T

type ParsedNestedField = {
  parentKey: string
  nestedPath: string[]
  parentAtom: unknown
  fieldPath: string
}

export const parseNestedField = (
  name: string,
  get: GetRecoilValue,
): ParsedNestedField | null => {
  if (!name.includes('.')) return null

  const [parentKey, ...nestedPath] = name.split('.')
  const parentAtom = get(caseValuesAtom(parentKey))

  return {
    parentKey,
    nestedPath,
    parentAtom,
    fieldPath: nestedPath.join('.'),
  }
}
